// extracted by mini-css-extract-plugin
export default {"container":"Boxes_container__1OVWK","content":"Boxes_content__EEZ6n","box":"Boxes_box__E76tz"};